import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const getPastOneOnOneApi = ({ masterId }: { masterId: number }) => {
  const url = endpoints.oneOnOneRevamped.pastOneOnOne(masterId);
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};
